module.exports = __webpack_public_path__ + "static/media/two-tokens.8a98c32b.svg";